import { render, staticRenderFns } from "./Rubrics.vue?vue&type=template&id=791d3bc2&scoped=true&"
import script from "./Rubrics.vue?vue&type=script&lang=js&"
export * from "./Rubrics.vue?vue&type=script&lang=js&"
import style0 from "./Rubrics.vue?vue&type=style&index=0&id=791d3bc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d3bc2",
  null
  
)

export default component.exports